import React, { Component } from 'react'
import './Contact.css'

class Contact extends Component {
    render() {
        return (
            <section>
                <div className="contact-pane">
                    <div className="contact-content">
                        <div className="contact-items">
                            <h2>Kapcsolat</h2>
                            <div><i className="fa fa-building" aria-hidden="true" /> <span>{this.props.contact.name}</span></div>
                            <div><i className="fa fa-map-marker" aria-hidden="true" /> <span>{this.props.contact.address}</span></div>
                            <div><i className="fa fa-envelope" aria-hidden="true" /> <a href={'mailto:' + this.props.contact.email}>{this.props.contact.email}</a></div>
                            <div><i className="fa fa-phone" aria-hidden="true" /> <span>{this.props.contact.phone}</span></div>
                            <div><i className="fa fa-fax" aria-hidden="true" /> <span>{this.props.contact.fax}</span></div>
                        </div>
                        <div className="contact-map-box">
                            <iframe title="footer-maps" className="contact-map" src="https://maps.google.com/maps?q=1145%20Budapest%2C%20Szugl%C3%B3%20utca%2049-51.%20I%2F5.&t=&z=13&ie=UTF8&iwloc=&output=embed" frameBorder="0" allowFullScreen></iframe>
                        </div>
                    </div>
                </div>
                <div style={{ textAlign: 'right', marginTop: '10px' }}><span>Created by: </span><a href="http://www.applixation.hu" target="_blank">Applixation Kft.</a></div>
            </section>
        )
    }
}

export default Contact


// WEBPACK FOOTER //
// ./src/components/contact/Contact.js